module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BC3FX0/tc-custom/9781423612629.jpg?1736882907787",
      "alt": "This image is the cover for the book 101 Things To Do With Pudding, 101 Things To Do With"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("101 Things To Do With Pudding, 101 Things To Do With\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("One simple dessert gives a sweet kick to breads, fruit salads, donuts, and more—from the bestselling author of")]), _c('b', [_c('i', [_vm._v("101 Things to Do with a Cake Mix")])]), _vm._v(". "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" There’s so much more to pudding than just a dollop of whipped cream on top! This all-time favorite treat gets a makeover with "), _c('i', [_vm._v("101 Things to Do with Pudding")]), _vm._v(". Instant pudding mix takes everyday desserts and pastries to another level including cinnamon buns, banana bread, muffins, no-bake oatmeal cookies, pies, fruit dip, milkshakes, pudding pops, parfaits, pound cakes, and dessert pizzas."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Now you can try some amazingly luscious, moist, and inventive recipes such as Sticky Buns, Banana Cream Cookie Salad, White Chocolate Coconut Cream Cookies, Triple Chocolate Brownies, Cream Cheese Chocolate Nut Pie, Red Velvet Cake, Pumpkin Spice Trifle, and a whole lot more!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephanie Ashcraft\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephanie Ashcraft, author of the original 101 Things To Do With A Cake Mix, has taught cooking classes based on the tips and meals in her cookbooks for almost twenty years. She lives in Tucson, Arizona.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0